import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CalendarioSsoCreateDefaultModel } from 'src/app/models/calendario-sso/CalendarioSsoCreateDefaultModel';
import { CalendarioSsoModel } from 'src/app/models/calendario-sso/CalendarioSsoModel';
import { UpdateFechaPruebaModel } from 'src/app/models/calendario-sso/UpdateFechaPruebaModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ICalendarioSsoModel } from 'src/app/models/interfaces/calendario-sso/ICalendarioSsoModel';
import { IFilterCalendarioSsoModel } from 'src/app/models/interfaces/calendario-sso/IFilterCalendarioSsoModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalendarioSsoService {
  private configUrl = [environment.apiGatewayUrl, 'calendario-sso'].join('/');
  constructor(private http: HttpClient,
    private datepipe: DatePipe) { }

    getList(
      model: IFilterCalendarioSsoModel
      // codigo: string,
      // contratista: string,
      // estado: number,
      // fecha: Date
    ): Observable<CalendarioSsoModel[]> {
      let queryParams: string[] = new Array<string>();
      
      queryParams.push(`anio=${model.anio}`);
      
      queryParams.push(`idCompania=${model.idCompania}`);
      
      return this.http.get<CalendarioSsoModel[]>(
        this.configUrl + '?'+ queryParams.join('&')
      );
    }

    getAnios(
    ): Observable<number[]> { 
      return this.http.get<number[]>(
        this.configUrl + '/anios'
      );
    }

    getById(id: number): Observable<CalendarioSsoModel> {
      return this.http.get<CalendarioSsoModel>(`${this.configUrl}/${id}`);
    }

    update(model: ICalendarioSsoModel) {
      return this.http.put<ActionResultModel>(
        `${this.configUrl}/${model.idCalendarioSso}`,
        model
      );
    }

    getCurrent(idCompania: number): Observable<CalendarioSsoModel> {
      let queryParams: string[] = new Array<string>();
      
      queryParams.push(`idCompania=${idCompania}`);
      return this.http.get<CalendarioSsoModel>(`${this.configUrl}/current`+ '?'+ queryParams.join('&'));
    }

    getFechaPrueba(): Observable<Date> {
      return this.http.get<Date>(`${this.configUrl}/fechaprueba`);
    }

    updateFechaPrueba(model: UpdateFechaPruebaModel) {
      return this.http.put<ActionResultModel>(
        `${this.configUrl}/fechaprueba`,
        model
      );
    }

    generar(model: CalendarioSsoCreateDefaultModel) {
      return this.http.post<ActionResultModel>(
        `${this.configUrl}/generar`,
        model
      );
    }
}
